var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSingleMan = function SvgSingleMan(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.625 7.28784C7.625 8.44816 8.08594 9.56096 8.90641 10.3814C9.72688 11.2019 10.8397 11.6628 12 11.6628C13.1603 11.6628 14.2731 11.2019 15.0936 10.3814C15.9141 9.56096 16.375 8.44816 16.375 7.28784C16.375 6.12752 15.9141 5.01472 15.0936 4.19425C14.2731 3.37378 13.1603 2.91284 12 2.91284C10.8397 2.91284 9.72688 3.37378 8.90641 4.19425C8.08594 5.01472 7.625 6.12752 7.625 7.28784Z",
    stroke: "#8C8C8C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.875 21.6628C3.875 19.508 4.73102 17.4413 6.25476 15.9176C7.77849 14.3939 9.84512 13.5378 12 13.5378C14.1549 13.5378 16.2215 14.3939 17.7452 15.9176C19.269 17.4413 20.125 19.508 20.125 21.6628",
    stroke: "#8C8C8C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSingleMan);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "single-man.9b9473f058675dc81817605605fc72f0.svg";